import { createSlice } from '@reduxjs/toolkit';

const storedLanguage = localStorage.getItem('selectedLanguage') || 'R';

const initialState = {
  selectedLanguage: storedLanguage,
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage(state, action) {
      state.selectedLanguage = action.payload;
      localStorage.setItem('selectedLanguage', action.payload);
    },
  },
});


export const { actions, reducer } = languageSlice;
